import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import WorkIcon from '@mui/icons-material/Work';
import HomeIcon from '@mui/icons-material/Home';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import PreviewSharpIcon from '@mui/icons-material/PreviewSharp';
import React from "react";
import Tooltip from '@mui/material/Tooltip';
import { CacheTypes } from "@utils/cache/interfaces";
import { cacheUtils } from "../../../../../../../../..";
import { ui, state } from "../../../../../../../../../interfaces/interfaces";
import { importAddressAndContact } from "../../../../../../JobSearchModal/JobsTable";
import { Divider } from "@mui/material";
import { RightioWBSAPIModelsJobsLast } from "@utils/apis/wbs/model";

const name = "JobDetailsCompleted";

interface JobDetailsCompletedProps {
    job: Required<RightioWBSAPIModelsJobsLast>;
    setOpen: any
    setJobId: any
}

const JobDetailsCompleted: React.FC<JobDetailsCompletedProps> = ({ setOpen, setJobId, job }) => {
    const updateUI = (jobId: number) => {
        setJobId(jobId)
        setOpen(true)
    }
    return (
        <Stack >
            <Stack direction="row" justifyContent="space-evenly" sx={{ p: 1 }} >
                <Tooltip title="Import Job (Go Back)" placement="bottom">
                    <WorkIcon onClick={() => updateUI(job.jobId!)} sx={{ ":hover": { cursor: "pointer" } }} />
                </Tooltip>
                <Tooltip title="Import address & contact details" placement="bottom">
                    <HomeIcon onClick={() => importAddressAndContact(job.jobId!)} />
                </Tooltip>
                <Tooltip title="Search for more..." placement="bottom">
                    <WorkHistoryIcon onClick={() => { ui.JobsSearchTerm = job.customerCLI || job.telephoneMobile || job.telephoneLandline || job.customerSurname!; ui.JobSearchModal = true; }} />
                </Tooltip>
                <Tooltip title="View Details..." placement="bottom">
                    <PreviewSharpIcon onClick={() => { state.CompletedJob = job.jobId!; ui.JobHistoryModal = true }} />
                </Tooltip>
            </Stack>
            <Typography sx={{ margin: 0 }}>{`${job.jobId} [${cacheUtils.getCache<CacheTypes.TradeTypes>("TradeTypes").filter((t) => t.tradeCode === job.tradeCode)?.[0]?.tradeDescription}] - ${new Date(job.dateTimeReceived || 0).toLocaleDateString("en-GB")}`}</Typography>
            <Typography sx={{ margin: 0 }}>{`Job: ${cacheUtils.getCache<CacheTypes.JobTypes>("JobTypes").filter((t) => t.jobTypeCode === job.jobTypeCode)?.[0]?.jobDescription}`}</Typography>
            <Typography sx={{ margin: 0 }}>{`Cust: ${job.customerTitle}. ${job.customerForename} ${job.customerSurname}`}</Typography>
            <Typography sx={{ margin: 0 }}>{`${job.property}, ${job.street}`}</Typography>
            <Typography sx={{ margin: 0 }}>{`${job.town}, ${job.postcode}`}</Typography>
            {job.emailAddress && <Typography sx={{ margin: 0 }}>{`Email: ${job.emailAddress}`}</Typography>}
            <Typography sx={{ margin: 0 }}>{`Phone: ${job.customerCLI || job.telephoneMobile || job.telephoneLandline}`}</Typography>
            <Divider />
        </Stack>
    )
}

JobDetailsCompleted.displayName = name;

export default React.memo(JobDetailsCompleted);